/* ===== art/tiles/cave.js — 동굴 — 이끼 · 종유 · 수정 · 금 간 자갈 · 운석 · 석회암·화강암 · 심층암·현무암·마그마 맥 · 균사 ===== */
import { shade } from '../../../engine/core/color.js';
import { TAU, clamp } from '../../../engine/core/math.js';
import { TS } from '../../world.js';
import { TILE_PAINT } from '../../tileart.js';
/* tileart.js TileArt.paint 의 갈래들 — 읽히는 순간 TILE_PAINT 에 붙는다. H 는 paint 의 인자·도우미 묶음, this 는 TileArt. */

export const TilePaintCave: Bag = {
  mossrock(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {            // 이끼 낀 바위 — 돌결 위에 이끼가 얼룩지고 윗면이 두툼하다
        this._fill(g, ox, oy, base);
        for (let i = 0; i < 6; i++) R(rng.range(-2, TS - 3), rng.range(-2, TS - 3), rng.range(4, 9), rng.range(3, 6), rng.chance(.5) ? lt : dk);
        this._speck(g, ox, oy, rng, 14, dk2, lt2);
        const m1 = s.g, m2 = shade(m1, 1.3), m3 = shade(m1, .7);
        for (let i = 0; i < 9; i++) {                           // 얼룩진 이끼
          const x = rng.range(0, TS - 4), y = rng.range(3, TS - 3);
          R(x, y, rng.range(2, 5), rng.range(1, 3), rng.chance(.6) ? m1 : m3);
        }
        let h = 4;
        for (let x = 0; x < TS; x++) {                          // 윗면 이끼
          h = clamp(h + rng.range(-1, 1), 2, 6);
          R(x, 0, 1, h, m1); R(x, 0, 1, 1, m2); R(x, h - 1, 1, 1, m3);
        }
        return;
      }
    }
  },
  hangmoss(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {            // 늘어진 이끼 — 가닥마다 길이가 다르고 끝이 가늘다
        R(0, 0, TS, 2, shade(base, .7));
        for (let x = 0; x < TS; x += 2) {
          const len = rng.int(6, TS - 1);
          R(x, 1, 2, len * .55, base);
          R(x + (rng.chance(.5) ? 0 : 1), 1 + len * .55, 1, len * .45, shade(base, .8));
          if (rng.chance(.4)) R(x, 2, 1, 2, lt2);
        }
        return;
      }
    }
  },
  dripstone(H: TilePaintKit) {
    const { s, v, R, base, dk, dk2, lt, lt2 } = H;
    // ★ 공유 난수(rng)를 뽑지 않는다 — 뒤 타일들 그림이 통째로 밀린다. 모양 갈래는 변형 번호로.
    // 종유석(위에 붙어 아래로) · 석순(바닥에서 위로) — 붙은 쪽이 퍼지고 몸은 불룩불룩 · 살짝 휜다(가방 그림 · 한 칸짜리)
    const up = !!s.up, ice = s.c === '#bfe6f5', ember = s.c === '#4a3c38' || s.c === '#40342f';
    const pal = [dk2, dk, base, lt, lt2], ph = v * 1.9 + 0.7, R0 = (TS - 2) / 2;
    for (let y = 0; y < TS; y++) {
      const yy = up ? TS - 1 - y : y, t = (yy + 0.5) / TS;
      let r = up ? R0 * (1 - Math.pow(t, 1.7)) * 0.95 + 0.6 : R0 * 0.9 * Math.pow(1 - t, 1.25) + 0.35;
      if (!ice) r += Math.sin(t * Math.PI * 2.4 + ph) * (1 - t) * 1.3;
      if (yy < 3) r = Math.max(r, TS / 2 - yy * 0.8);
      if (r < 0.45) continue;
      const cx = TS / 2 + Math.sin(t * 2.6 + ph) * 1.4 * t;
      for (let x = Math.max(0, Math.round(cx - r)); x <= Math.min(TS - 1, Math.round(cx + r) - 1); x++) {
        const u = (x + 0.5 - cx) / Math.max(1, r);
        const k = 2.6 - u * 1.35 - (Math.abs(u) > 0.78 ? 0.9 : 0) - (!ice && yy % 7 === 0 ? 0.8 : 0);
        R(x, y, 1, 1, pal[Math.max(0, Math.min(4, Math.round(k)))]);
        if (ember && Math.abs(u) < 0.35 && (yy * 7 + x * 3) % 13 < 2) R(x, y, 1, 1, t > 0.55 ? '#ffb05a' : '#c8401a');
      }
    }
    if (!up) R(TS / 2 - .5, TS - 2, 1, 2, ember ? '#ff8a3a' : ice ? '#e8f8ff' : '#9fd0e8');   // 끝에 맺힌 물방울 · 불씨
  },
  geode(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {               // 수정 무리 — 바닥에서 여러 갈래로 솟은 결정
        const cols = [base, lt, lt2, shade(base, .8)];
        for (const [bx, h, w, lean] of [[6, 14, 5, -1.5], [12, 19, 6, 0.5], [17, 11, 4, 2]]) {
          g.fillStyle = cols[rng.int(0, 3)];
          g.beginPath();
          g.moveTo(ox + bx - w / 2, oy + TS); g.lineTo(ox + bx + w / 2, oy + TS);
          g.lineTo(ox + bx + w / 2 + lean, oy + TS - h + 3); g.lineTo(ox + bx + lean, oy + TS - h);
          g.lineTo(ox + bx - w / 2 + lean, oy + TS - h + 3); g.closePath(); g.fill();
          R(bx + lean - .5, TS - h + 2, 1, h - 4, '#ffffff');    // 결정 모서리의 빛
        }
        g.globalAlpha = .22; g.fillStyle = lt2;
        g.beginPath(); g.arc(ox + TS / 2, oy + TS - 8, 10, 0, TAU); g.fill();
        g.globalAlpha = 1;
        return;
      }
    }
  },
  fault(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {               // 금 간 자갈 — 돌 바탕에 알갱이 결이 옅게, 가는 금 하나
        /* ★ 바탕을 돌과 같은 밝기(base)로 깐다. */
        this._fill(g, ox, oy, base);
        for (let i = 0; i < 7; i++) R(rng.range(-2, TS - 3), rng.range(-2, TS - 3), rng.range(4, 9), rng.range(3, 6), rng.chance(.5) ? lt : dk);
        for (let i = 0; i < 9; i++) {
          const x = rng.range(1, TS - 5), y = rng.range(1, TS - 5), r = rng.range(1.4, 2.4);
          g.fillStyle = rng.chance(.5) ? shade(base, 1.1) : shade(base, .9);
          g.beginPath(); g.arc(ox + x + r, oy + y + r, r, 0, TAU); g.fill();
        }
        this._speck(g, ox, oy, rng, 16, dk2, lt2);
        /* 금은 네 변형 중 하나에만, 짧게 — 칸마다 같은 자리에 금을 그었더니 자갈 덩어리가 격자 무늬로 드러났다(변형이 넷뿐이라 금 자리가 되풀이된다). */
        if (v === 1) {
          let x = rng.range(4, TS - 6), y = rng.range(2, 8);
          for (let k = 0; k < 8; k++) { R(x, y, 1, 1, dk2); x = clamp(x + rng.range(-1.2, 1.4), 1, TS - 2); y += 1.2; }
        }
        return;
      }
    }
  },
  meteorite(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {           // 운석 — 오목 자국 · 쇠 알갱이 · 식다 만 금
        this._fill(g, ox, oy, base);
        for (let i = 0; i < 5; i++) R(rng.range(-2, TS - 3), rng.range(-2, TS - 3), rng.range(4, 9), rng.range(3, 6), rng.chance(.5) ? lt : dk);
        for (let i = 0; i < 4; i++) {               // 오목 자국 — 위 가장자리는 그늘, 아래 가장자리는 빛
          const x = rng.range(3, TS - 4), y = rng.range(3, TS - 4), r = rng.range(2.2, 3.6);
          g.fillStyle = dk2; g.beginPath(); g.arc(ox + x, oy + y, r, 0, TAU); g.fill();
          g.fillStyle = dk; g.beginPath(); g.arc(ox + x + .6, oy + y + .8, r * .75, 0, TAU); g.fill();
          g.fillStyle = lt; g.beginPath(); g.arc(ox + x, oy + y, r, .3, 2.6); g.lineTo(ox + x, oy + y); g.fill();
        }
        for (let i = 0; i < 9; i++) R(rng.range(1, TS - 3), rng.range(1, TS - 3), rng.chance(.4) ? 2 : 1, 1, rng.chance(.5) ? '#c8ccd4' : '#8a8e98');
        if (v === 1 || v === 3) {                   // 붉은 금 — 넷 중 둘에만, 짧게(칸마다 그으면 줄무늬가 된다)
          let x = rng.range(4, TS - 6), y = rng.range(3, 9);
          for (let k = 0; k < 6; k++) {
            R(x, y, 1, 1, '#ff7a3a'); if (k % 3 === 0) R(x + 1, y, 1, 1, '#ffb070');
            x = clamp(x + rng.range(-1.3, 1.3), 1, TS - 2); y += 1.4;
          }
        }
        this._speck(g, ox, oy, rng, 10, dk2, lt2);
        return;
      }
    }
  },
  starcrystal(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {         // 별빛 수정 — 가늘고 곧은 결정 다발, 끝에 별빛이 맺힌다
        g.globalAlpha = .2; g.fillStyle = lt2;
        g.beginPath(); g.arc(ox + TS / 2, oy + TS - 6, 9, 0, TAU); g.fill();
        g.globalAlpha = 1;
        const sets = [[[5, 11, 3, -2], [11, 20, 4, 0], [16, 14, 3, 2.5]],
          [[7, 17, 4, -1], [14, 12, 3, 1.5], [18, 8, 2.5, 3]],
          [[4, 9, 3, -2.5], [9, 15, 3.5, -.5], [15, 19, 4, 1]],
          [[6, 13, 3.5, -1.5], [12, 17, 3, .5], [17, 11, 3, 2]]][v & 3];
        for (const [bx, h, w, lean] of sets) {
          const tipX = ox + bx + lean, tipY = oy + TS - h;
          g.fillStyle = shade(base, .82);
          g.beginPath(); g.moveTo(ox + bx - w / 2, oy + TS); g.lineTo(ox + bx + w / 2, oy + TS);
          g.lineTo(tipX + w / 2, tipY + 3); g.lineTo(tipX, tipY); g.lineTo(tipX - w / 2, tipY + 3); g.closePath(); g.fill();
          g.fillStyle = lt2;                        // 빛 받는 쪽 면
          g.beginPath(); g.moveTo(ox + bx - w / 2, oy + TS); g.lineTo(ox + bx, oy + TS);
          g.lineTo(tipX, tipY); g.lineTo(tipX - w / 2, tipY + 3); g.closePath(); g.fill();
          R(bx + lean - .5, TS - h + 2, 1, h - 4, '#ffffff');
          R(bx + lean - 1.5, TS - h - .5, 3, 1, '#fffbe8');   // 끝의 별빛(십자)
          R(bx + lean - .5, TS - h - 1.5, 1, 3, '#fffbe8');
        }
        R(0, TS - 2, TS, 2, '#2e2a2e');             // 뿌리 — 녹아 굳은 바닥에 박힌 자리
        return;
      }
    }
  },
  fused(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {               // 녹아 굳은 돌 — 검은 유리 바탕, 흘러 굳은 결과 공기 방울, 윤
        this._fill(g, ox, oy, base);
        for (let i = 0; i < 4; i++) {
          let x = rng.range(0, TS - 4), y = rng.range(1, TS - 2);
          for (let k = 0; k < 10; k++) { R(x, y, 2, 1, rng.chance(.5) ? dk : shade(base, 1.12)); x += 1.8; y += rng.range(-.6, .6); }
        }
        for (let i = 0; i < 5; i++) {
          const x = rng.range(2, TS - 3), y = rng.range(2, TS - 3);
          R(x, y, 2, 2, dk2); R(x, y, 1, 1, lt2);
        }
        R(rng.range(2, 8), rng.range(2, 6), rng.range(5, 9), 1, '#6a6070');   // 유리 윤
        R(rng.range(10, 16), rng.range(12, 18), rng.range(3, 6), 1, '#5a5060');
        if (v === 1) R(rng.range(3, TS - 5), rng.range(3, TS - 5), 2, 1, '#c85a2a');   // 아직 붉은 한 점
        return;
      }
    }
  },
  granite(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {             // 화강암 — 바탕 위에 밝은 알갱이·검은 알갱이가 굵게 박힌다
        this._fill(g, ox, oy, base);
        for (let i = 0; i < 5; i++) R(rng.range(-2, TS - 3), rng.range(-2, TS - 3), rng.range(4, 8), rng.range(3, 6), rng.chance(.5) ? lt : dk);
        for (let i = 0; i < 22; i++) R(rng.range(0, TS - 2), rng.range(0, TS - 2), 2, 2, rng.chance(.5) ? '#d8c8c0' : '#2a2224');
        this._speck(g, ox, oy, rng, 16, dk2, lt2);
        return;
      }
    }
  },
  deepslate(H: TilePaintKit) {
    const { g, ox, oy, rng, R, base, dk, dk2, lt, lt2 } = H;   // 심층암 — 눌려 굳은 얇은 켜가 가로로, 켜 사이 검은 틈
    this._fill(g, ox, oy, base);
    let y = rng.range(-1, 2);
    while (y < TS) {
      const h = rng.range(2.5, 4.5);
      R(0, y, TS, 1, dk2);                                          // 켜 사이 틈
      for (let x = 0; x < TS; x += rng.range(3, 7)) R(x, y + 1, rng.range(2, 5), Math.max(1, h - 2), rng.chance(.5) ? lt : dk);
      y += h;
    }
    for (let i = 0; i < 6; i++) R(rng.range(0, TS - 2), rng.range(0, TS - 1), 2, 1, lt2);   // 반짝이는 운모 조각
  },
  basalt(H: TilePaintKit) {
    const { g, ox, oy, rng, v, R, base, dk, dk2, lt } = H;   // 현무암 — 식으며 갈라진 기둥결: 세로 금 둘 + 엇갈린 가로 마디
    this._fill(g, ox, oy, base);
    const c1 = 5 + (v % 3), c2 = 12 + (v % 4);
    for (const [x0, x1] of [[0, c1], [c1 + 1, c2], [c2 + 1, TS]]) {
      R(x0, 0, 1, TS, lt);                                          // 기둥 왼쪽 모서리 빛
      const j = rng.range(4, TS - 4);
      R(x0, j, x1 - x0, 1, dk2);                                    // 마디
      for (let i = 0; i < 3; i++) R(rng.range(x0, x1 - 1), rng.range(0, TS - 1), 1, 1, dk);
    }
    R(c1, 0, 1, TS, dk2); R(c2, 0, 1, TS, dk2);
  },
  magmavein(H: TilePaintKit) {
    const { g, ox, oy, rng, v, R, base, dk2, lt } = H;   // 마그마 맥 — 현무암 바탕에 붉게 달아오른 금이 꺾이며 지난다
    this._fill(g, ox, oy, base);
    for (let i = 0; i < 8; i++) R(rng.range(0, TS - 3), rng.range(0, TS - 2), rng.range(2, 4), 1, rng.chance(.5) ? lt : dk2);
    let x = v % 2 ? 0 : rng.range(4, TS - 6), y = v % 2 ? rng.range(4, TS - 6) : 0;
    const horiz = v % 2 === 1;
    for (let s = 0; s < 12; s++) {
      R(x - 1, y - 1, 3, 3, '#7a1e0e');                             // 달아오른 둘레
      R(x, y, 2, 2, '#ff6a1e');
      if (s % 3 === 1) R(x + .5, y + .5, 1, 1, '#ffd27a');          // 가장 뜨거운 속
      if (horiz) { x += 2; y = clamp(y + rng.range(-1.6, 1.6), 2, TS - 4); } else { y += 2; x = clamp(x + rng.range(-1.6, 1.6), 2, TS - 4); }
    }
  },
  hyphae(H: TilePaintKit) {
    const { g, ox, oy, s, rng, v, seed, R, base, dk, dk2, lt, lt2 } = H;
    { {              // 균사 발 — 천장에서 내린 실이 아래로 갈수록 성글다
        R(0, 0, TS, 2, shade(base, .62));                       // 붙어 있는 자리
        for (let x = 1; x < TS; x += 3) {
          const len = 6 + ((x * 7) % 11);
          R(x, 2, 1, len, base);
          R(x, 2, 1, Math.min(3, len), lt2);                    // 위쪽이 굵고 밝다
          if (len > 12) R(x, 2 + len, 1, 1, lt2);               // 끝에 맺힌 것
        }
        for (const [bx, by] of [[4, 7], [13, 10], [8, 14]]) R(bx, by, 2, 2, lt2);   // 실에 걸린 포자
        return;
      }
    }
  },
};
Object.assign(TILE_PAINT, TilePaintCave);
